var map = {
	"./add.svg": 24402,
	"./addFile.svg": 22096,
	"./application.svg": 14065,
	"./bells_icon.svg": 33583,
	"./circle_icon.svg": 28183,
	"./code_icon.svg": 39002,
	"./draw.svg": 23387,
	"./echarts.svg": 55037,
	"./edit.svg": 95869,
	"./email_icon.svg": 89845,
	"./female_avatar.svg": 95919,
	"./font.svg": 56982,
	"./item.svg": 23572,
	"./lock_icon.svg": 60436,
	"./phone_icon.svg": 69733,
	"./questionnaire.svg": 672,
	"./questions.svg": 66556,
	"./rank_ranking.svg": 9460,
	"./rank_score.svg": 74264,
	"./rank_time.svg": 18961,
	"./search.svg": 58217,
	"./switch.svg": 69377,
	"./time2.svg": 12168,
	"./titck.svg": 50082,
	"./user.svg": 68848,
	"./user_icon.svg": 84216,
	"./vote.svg": 64073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;